/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import cx from 'classnames';
import { useTheme } from '../../utils/index.js';
/**
 * Shows progress on a linear bar
 * @example
 * Determinate
 * <ProgressLinear value={25}/>
 * Indeterminate
 * <ProgressLinear indeterminate={true}/>
 * Labeled - Center
 * <ProgressLinear value={50} labels={['Centered Label']} />
 * Labeled - Left & Right
 * <ProgressLinear value={50} labels={['Loading...', '50%']} />
 * Positive / Negative.
 * <ProgressLinear status='positive' labels={['Upload done!', <SvgStatusSuccessHollow />]} />
 * <ProgressLinear status='negative' />
 */
export const ProgressLinear = (props) => {
    const { value = 0, indeterminate = false, labels = [], isAnimated = false, status, className, style, ...rest } = props;
    useTheme();
    const boundedValue = Math.min(100, Math.max(0, value));
    return (React.createElement("div", { className: cx('iui-progress-indicator-linear', {
            [`iui-${status}`]: !!status,
        }, className), style: style, ...rest },
        React.createElement("div", { className: 'iui-track' },
            React.createElement("div", { className: cx('iui-fill', {
                    'iui-determinate': !indeterminate && isAnimated,
                    'iui-indeterminate': indeterminate,
                }), style: { width: indeterminate ? '100%' : `${boundedValue}%` } })),
        labels.length > 0 && (React.createElement("div", { className: 'iui-label' }, labels.map((label, index) => (React.createElement("span", { key: index }, label)))))));
};
export default ProgressLinear;
